'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import UIFieldset from 'UIComponents/form/UIFieldset';
export default function ToolFieldset(props) {
  return /*#__PURE__*/_jsx(UIFieldset, Object.assign({}, props, {
    _size: "small"
  }));
}